import React from "react";
import styles from "./styles.module.scss";

const FileUploaderInput = ({ label, onChange, file, existingFile }) => {
  const displayedName =
    file?.name || existingFile?.name || "No file chosen";

  const handleFileClick = () => {
    if (file) {
      window.open(URL.createObjectURL(file), "_blank");
    } else if (existingFile?.url) {
      window.open(existingFile.url, "_blank");
    }
  };

  return (
    <div className={styles.fileUploadContainer}>
      {label && <p className={styles.label}>{label}:</p>}

      <div className={styles.fileInputWrapper}>
        <label htmlFor="fileInput" className={styles.fileInputLabel}>
          Choose File
        </label>

        <input
          id="fileInput"
          type="file"
          accept="application/pdf"
          className={styles.fileInput}
          onChange={onChange}
        />

        <p
          className={`${styles.fileName} ${
            file || existingFile ? styles.clickable : ""
          }`}
          onClick={file || existingFile ? handleFileClick : undefined}
        >
          {displayedName}
        </p>
      </div>
    </div>
  );
};

export default FileUploaderInput;
